import { render, staticRenderFns } from "./Subcontract.vue?vue&type=template&id=01b30436&scoped=true"
import script from "./Subcontract.vue?vue&type=script&lang=js"
export * from "./Subcontract.vue?vue&type=script&lang=js"
import style0 from "./Subcontract.vue?vue&type=style&index=0&id=01b30436&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b30436",
  null
  
)

export default component.exports